import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";

const rawDataWeek = [
  {
    Lable: "20",
    Score: 1,
    MaxScore: 5,
  },
  {
    Lable: "21",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "22",
    Score: 5,
    MaxScore: 5,
  },
  {
    Lable: "23",
    Score: 5,
    MaxScore: 5,
  },
  {
    Lable: "24",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "25",
    Score: 0,
    MaxScore: 5,
  },
];

const rawData = [
  {
    Lable: "January",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "Febuary",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "March",
    Score: 3,
    MaxScore: 5,
  },
  {
    Lable: "April",
    Score: 4,
    MaxScore: 5,
  },
  {
    Lable: "May",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "June",
    Score: 3,
    MaxScore: 5,
  },
];
const rawDataDay = [
  {
    Lable: "1 June",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "2 June",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "3 June",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "4 June",
    Score: 3,
    MaxScore: 5,
  },
  {
    Lable: "5 June",
    Score: 4,
    MaxScore: 5,
  },
  {
    Lable: "6 June",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "7 June",
    Score: 3,
    MaxScore: 5,
  },
  {
    Lable: "8 June",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "9 June",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "10 June",
    Score: 3,
    MaxScore: 5,
  },
  {
    Lable: "12 June",
    Score: 4,
    MaxScore: 5,
  },
  {
    Lable: "13 June",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "14 June",
    Score: 3,
    MaxScore: 5,
  },
  {
    Lable: "15 June",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "16 June",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "17 June",
    Score: 3,
    MaxScore: 5,
  },
  {
    Lable: "18 June",
    Score: 4,
    MaxScore: 5,
  },
  {
    Lable: "19 June",
    Score: 2,
    MaxScore: 5,
  },
  {
    Lable: "20 June",
    Score: 3,
    MaxScore: 5,
  },
];
const MyBarChart = ({ context, timeInterval, rawData }) => {
  const [xAxisData, setXAxisData] = useState([]);
  const [seriesData, setSeriesData] = useState([]);
  useEffect(() => {
    let data;
    data = StructureData(rawData);
    setXAxisData(data.xAxisData);
    setSeriesData(data.seriesData);
  }, [rawData]);
  const StructureData = (data) => {
    const xAxisData = [];
    const seriesData = [];
    data.forEach((ele) => {
      xAxisData.push(ele.Lable);
      seriesData.push(ele.Score);
    });
    return {
      xAxisData,
      seriesData,
    };
  };
  const handleFlag = () => {
    if (timeInterval == 2) {
      return "Days";
    } else if (timeInterval == 3) {
      return "Weeks";
    } else {
      return "Month";
    }
  };
  const handleTitle = () => {
    if (context == 1) {
      return "SG Punctuality";
    } else if (context == 2) {
      return "Cleanliness";
    } else if (context == 3) {
      return "Consumable Availablity";
    } else if (context == 4) {
      return "Branch Hygiene";
    } else if (context == 5) {
      return "Security Guard";
    } else if (context == 6) {
      return "Compitence Level";
    } else if (context == 7) {
      return "House Keeper Quality";
    } else if (context == 8) {
      return "Washroom Cleaning";
    } else {
      return "Four";
    }
  };

  return (
    <>
      <BarChart
        xAxis={[
          {
            data: xAxisData,
            scaleType: "band", // Ensure the x-axis is of type 'band'
            label: `${handleFlag()}`,
          },
        ]}
        yAxis={[
          {
            label: "Average Rating",
          },
        ]}
        series={[
          {
            data: seriesData,
            label: `${handleTitle()}`,
          },
        ]}
        height={400}
        // width={600}
      />
    </>
  );
};

export default MyBarChart;
